var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Intro",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 20,
    height: 18.039,
    transform: "translate(-7311 7284)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(7313 -7281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(-7311 7284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M8.318-11.215S6.668-8.233,7-7.741c.186.276,5.732-5.226,6.191-4.846.194.161-4.621,5.033-4.479,5.459a4.239,4.239,0,0,1,3.731,2.314c2.508-.743,6.243-4.748,6.765-3.9.555.9-6.141,5.234-6.141,6.27,0,.42,5.454-3.8,5.463-3.105.007.5-4.749,5.059-5.558,6.533a7.1,7.1,0,0,1-6.5,4.292A6.471,6.471,0,0,1,0-1.192C0-4.766,8.318-11.215,8.318-11.215Z",
    transform: "translate(0.784 12.606)",
    fill: "#eff0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M8.318-11.215S6.668-8.233,7-7.741c.186.276,5.732-5.226,6.191-4.846.194.161-4.621,5.033-4.479,5.459a4.239,4.239,0,0,1,3.731,2.314c2.508-.743,6.243-4.748,6.765-3.9.555.9-6.141,5.234-6.141,6.27,0,.42,5.454-3.8,5.463-3.105.007.5-4.749,5.059-5.558,6.533a7.1,7.1,0,0,1-6.5,4.292A6.471,6.471,0,0,1,0-1.192C0-4.766,8.318-11.215,8.318-11.215Z",
    transform: "translate(0 12.606)",
    fill: "#ffe3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M6.2.754c3.032,0,4.78,2.162,4.78,5.194A5.49,5.49,0,0,1,0,5.949C0,2.917,3.168.754,6.2.754Z",
    transform: "translate(1.176 5.662)",
    fill: "#feb64e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M4.548.923c2.166,0,3.3,1.394,3.3,3.559A3.922,3.922,0,0,1,0,4.483C0,2.317,2.382.923,4.548.923Z",
    transform: "translate(2.745 7.127)",
    fill: "#fea627"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/Intro.58acb47a.svg";
export { ForwardRef as ReactComponent };